import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useGoalsStore } from "@/apps/goals/store/goalsStore";
import { GoalMultiplierLockedModal } from "./GoalMultiplierLockedModal";
import cls from "./styles.module.scss";
import { LockedMarkerImage } from "../../assets/icons";

interface GoalMultiplierLockedMarkerProps {
  progress: number;
  rewardAmount: number;
}

export const GoalMultiplierLockedMarker = ({
  progress,
  rewardAmount,
}: GoalMultiplierLockedMarkerProps) => {
  const { t } = useTranslation();
  const shouldShowMultiplierIntro = useGoalsStore(
    (state) => state.shouldShowMultiplierIntro
  );
  const closeMultiplierIntro = useGoalsStore(
    (state) => state.closeMultiplierIntro
  );
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    if (!shouldShowMultiplierIntro) return;

    setIsModalOpen(true);
    closeMultiplierIntro();
  }, [closeMultiplierIntro, shouldShowMultiplierIntro]);

  return (
    <>
      <button
        className={cls.lockedMarker}
        type="button"
        onClick={() => setIsModalOpen(true)}
        aria-label={t("goals.multiplier.lockedLabel")}
      >
        <span className={cls.lockedMarkerImageWrap}>
          <LockedMarkerImage />
        </span>
        <span className={cls.lockedMarkerLabel}>
          {t("goals.multiplier.lockedLabel")}
        </span>
      </button>

      <GoalMultiplierLockedModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        progress={progress}
        rewardAmount={rewardAmount}
      />
    </>
  );
};
